"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSignInWithProvider = void 0;
const useSearchQueryParam_1 = require("root/src/client/v2/common/hooks/useSearchQueryParam");
const loginWith_1 = require("root/src/client/v2/auth/helpers/loginWith");
const providerHelpers_1 = require("root/src/client/v2/auth/helpers/providerHelpers");
const useAuthentication_1 = require("root/src/client/v2/auth/hooks/useAuthentication");
const useLocation_1 = require("root/src/client/v2/browser/hooks/useLocation");
const useSignInWithProvider = (params) => {
    const [providerSearchParam] = (0, useSearchQueryParam_1.useSearchQueryParam)({
        param: 'provider', disableParamsReplace: true,
    });
    const { authentication } = (0, useAuthentication_1.useAuthentication)();
    const provider = params.provider || providerSearchParam;
    if (!provider) {
        throw new Error('Provider is required');
    }
    const providerLabel = (0, providerHelpers_1.getReadableProviderName)(provider);
    const { pathname } = (0, useLocation_1.useLocation)();
    const state = {
        pathname,
    };
    const onSignIn = () => __awaiter(void 0, void 0, void 0, function* () {
        if (params.isLinking) {
            const token = authentication === null || authentication === void 0 ? void 0 : authentication.accessToken;
            if (!token) {
                throw new Error('Make sure you are logged in');
            }
            yield (0, loginWith_1.loginWith)(provider)(state)(token);
            return;
        }
        yield (0, loginWith_1.loginWith)(provider)(state)();
    });
    return {
        providerLabel,
        onSignIn,
        provider,
    };
};
exports.useSignInWithProvider = useSignInWithProvider;
